"use client";

import { useSignOut } from "@/app/_components/hooks/useSignOut";
import { Button } from "@/app/_components/ui/button";
import type { AuthUserInfo } from "@/auth";
import getLogger from "@/lib/logger";

const logger = getLogger("SignedInHeaderActions");

/**
 * The top-right of a page outside the app shell when someone is signed in:
 * the impersonation banner (with Stop) and Sign out.
 */
export const SignedInHeaderActions = ({
  authUserInfo,
  isImpersonating = false,
}: {
  authUserInfo: AuthUserInfo;
  isImpersonating?: boolean;
}) => {
  const handleSignOut = useSignOut();

  const handleStopImpersonation = async () => {
    let redirectUrl = "/";
    try {
      const res = await fetch("/api/auth/stop-impersonation", {
        method: "POST",
      });
      const data = await res.json();
      redirectUrl = data.redirectUrl;
    } catch (error) {
      logger.error(error, "Error stopping impersonation");
    } finally {
      window.location.href = redirectUrl;
    }
  };

  return (
    <div className="flex items-center gap-3">
      {isImpersonating && (
        <div className="flex-none rounded-sm bg-yellow-200 px-3 py-2 text-center font-medium text-black">
          {`Currently impersonating ${authUserInfo.firstName} ${authUserInfo.lastName}. `}
          <Button
            variant="link"
            size="inline"
            onClick={handleStopImpersonation}
            className="mx-1"
          >
            Stop
          </Button>
        </div>
      )}
      <Button
        variant="link"
        size="inline"
        onClick={handleSignOut}
        className="text-muted-foreground text-sm font-light justify-start"
      >
        Sign out
      </Button>
    </div>
  );
};
